import { KeyValuePair } from '../models';

const BU_CODE_FIELD = 'BU_CODE';
// Matches the Store Code filter field so the select shows the pre-selected store.
const DEFAULT_BU_CODE_KEY = 'bu_code';

export const isBuCodeFilter = (filter: KeyValuePair): boolean =>
  filter.key.toUpperCase() === BU_CODE_FIELD;

export const ensureBuCodeFilter = (
  filters: KeyValuePair[],
  defaultBuCode: string
): KeyValuePair[] => {
  // URLs saved before this fix use BU_CODE; rewrite them so the Store Code select can match.
  const normalized = filters.map(filter =>
    isBuCodeFilter(filter)
      ? { key: DEFAULT_BU_CODE_KEY, value: filter.value.replace(/^\w+/, DEFAULT_BU_CODE_KEY) }
      : filter
  );
  if (normalized.some(isBuCodeFilter)) {
    return normalized;
  }

  return [
    ...normalized,
    { key: DEFAULT_BU_CODE_KEY, value: `${DEFAULT_BU_CODE_KEY}.eq(${defaultBuCode})` },
  ];
};
